import { useEffect , useState,useRef} from "react";
import { teamTimerConverter } from "../../utils/utils";
import React from "react";
import  secureLocalStorage  from  "react-secure-storage";
import userEvent from "@testing-library/user-event";
import { useContext } from "react";
import { WebsocketContext } from "../../websocket/context";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearleftSecureLocalStorage } from "../../utils/utils";
import { FinishDebate } from "../../redux/actions/websocket_actions/finishe_debate_action";

function TeamTimer({team,total_hour,total_minutes,joined_as,virtual_id}){
    const [ready, val, send] = useContext(WebsocketContext); 
    const member = useSelector((state)=>state.removeMemberReducer);
    const debate_status = useSelector((state)=>state.finishDebateReducer);
    const dispatch = useDispatch()

    var total_second
    if((team === "left_team") || (team === "right_team")){
        let [hour,minutes,second] = teamTimerConverter(total_hour,total_minutes)
        total_hour = hour
        total_minutes = minutes
        total_second = second
 

    }

       
    const hour = parseInt(total_hour)
    const minutes = parseInt(total_minutes)
    const second = parseInt(total_second)
   
    const [pause,setPause] = useState(false);
    const [leftPause,setLeftPause] = useState(false);
    const [rightPause,setRightPause] = useState(false);
    const [speakingTeam,setSpeakingTeam] = useState();
    useEffect(()=>{
        const temp = JSON.parse(val)
        if(temp.action === 'timer'){
            if(temp.data.team === "left_team"){
                console.log("inside left team")
                secureLocalStorage.setItem("leftspeak",temp.data.pause)
                // secureLocalStorage.setItem("rightspeak",!temp.data.pause)
            }
            if(temp.data.team === "right_team"){
                console.log("inside right team")
                secureLocalStorage.setItem("rightspeak",temp.data.pause)
                // secureLocalStorage.setItem("leftspeak",!temp.data.pause)
              
            }
            if(temp.data.team === "both_team"){
                console.log("inside both room")
                secureLocalStorage.setItem("leftspeak",temp.data.pause)
                secureLocalStorage.setItem("rightspeak",temp.data.pause)

            }
            setSpeakingTeam(temp.data.team)
            // secureLocalStorage.setItem("started",temp.data.pause)
            // setPause(secureLocalStorage.getItem("started"))
            setLeftPause(secureLocalStorage.getItem("leftspeak"))
            setRightPause(secureLocalStorage.getItem("rightspeak"))
        }

        if(temp.action === "status"){
            if((temp.data.status)){
                if(temp.data.team == "left_team"){
                    secureLocalStorage.setItem("leftspeak",false)
                    setLeftPause(secureLocalStorage.getItem("leftspeak"))
                    clearleftSecureLocalStorage();
                }
            }
        }
    },[val])

    useEffect(()=>{
        console.log(debate_status,"from team timer")

        if((debate_status.is_finish) && (joined_as!="participant")){
            send(JSON.stringify({action:"status",data:{status:debate_status.is_finish,team:debate_status.team}}))
        } 

    },[debate_status])



    var s =0
    var m = 0
    var h = 0
    var max = 59
    const checkValue = (value) => {
            if (value < 10) {
                value = '0'+parseInt(value)
                return value;
            } else {
                return value;
            }
        }

    const left_team_timer=()=>{
        const oneSec = 1000
        const container1 = document.getElementById('team1Timer');

        while (container1.hasChildNodes()){
            container1.firstChild.remove()

        };
        let dataHours = secureLocalStorage.getItem("hour-left") ? checkValue(secureLocalStorage.getItem("hour-left")):container1.getAttribute('data-hours1')
        let dataMinutes = secureLocalStorage.getItem("min-left") ? checkValue(secureLocalStorage.getItem("min-left")):container1.getAttribute('data-minutes1')
        let dataSeconds = secureLocalStorage.getItem("sec-left") ? checkValue(secureLocalStorage.getItem("sec-left")):container1.getAttribute('data-seconds1')
        let timerEnd = container1.getAttribute('data-timer-end-left')
        let timerOnEndMsg = "data-timer-end-left";
        

        if (dataHours == '' || dataHours == null || dataHours == NaN) {
            dataHours = "0";
        }
        if (dataMinutes == '' || dataMinutes == null || dataMinutes == NaN) {
            dataMinutes = "0";
        }
        if (dataSeconds == '' || dataSeconds == null || dataSeconds == NaN) {
            dataSeconds = "0";
        }

        
        var hoursSpan = document.createElement('span')
        hoursSpan.id = "span_hour"
        var minutesSpan = document.createElement('span')
        minutesSpan.id = "span_minutes"
        var secondsSpan = document.createElement('span')
        secondsSpan.id = "span_seconds"
        var separator1 = document.createElement('span')
        separator1.id = "span_separator_1"
        var separator2 = document.createElement('span')
        separator2.id = "span_separator_2"

    
        let separatorValue = ":"
        let max = 59,


        s = parseInt(dataSeconds) > max ? max : parseInt(dataSeconds),
        m = parseInt(dataMinutes) > max ? max : parseInt(dataMinutes),
        h = parseInt(dataHours);


        secondsSpan.classList.add('time');
        minutesSpan.classList.add('time');
        hoursSpan.classList.add('time');
        separator1.classList.add('separator');
        separator1.textContent = separatorValue;
        separator2.classList.add('separator');
        separator2.textContent = separatorValue;

        hoursSpan.textContent =  checkValue(dataHours);
        minutesSpan.textContent =  checkValue(dataMinutes);
        secondsSpan.textContent = checkValue(dataSeconds);

        let children = [hoursSpan, separator1, minutesSpan, separator2, secondsSpan];

        for (let child of children) {
            container1.appendChild(child);
        }
       
    
    const timer = function (sv, mv, hv) {
            s = parseInt(sv);
            m = parseInt(mv);
            h = parseInt(hv);
        
            if (s > 0) {
                return s -= 1;
            } else {
                s = max;
                if (m > 0) {
                    return m -= 1;
                } else {
                    m = max;
                    if (h > 0) {
                        return h -= 1;
                    }
                }
            }
        }
    
    const finished1 = () => {
        let timerEnd1 = container1.getAttribute(timerOnEndMsg);
        if(joined_as!="participant"){
            dispatch(FinishDebate("left_team",virtual_id)) //this dispatch only when debate is finish from mediator side only
        }
        clearleftSecureLocalStorage();
        container1.setAttribute(timerOnEndMsg, "You're done!");
        if (timerEnd == '' || timerEnd== null) {
            container1.textContent = "You're done!";
        } else {
            container1.textContent = timerEnd;
        }
    }
    
    const counter1 =  setInterval(() => {
        if(secureLocalStorage.getItem("leftspeak")){
            if (h == 0 && m == 0 && s == 0) {
                secureLocalStorage.setItem("leftspeak",false)
                secureLocalStorage.setItem('hour-left',checkValue(0))
                secureLocalStorage.setItem('min-left',checkValue(0))
                secureLocalStorage.setItem('sec-left',checkValue(0))
                clearInterval(counter1, finished1());
            }
            if (s >= 0) {
                    timer(s, m, h);
                    secureLocalStorage.setItem('hour-left',checkValue(h))
                    secureLocalStorage.setItem('min-left',checkValue(m))
                    secureLocalStorage.setItem('sec-left',checkValue(s))

                    hoursSpan.textContent = checkValue(h);
                    minutesSpan.textContent = checkValue(m);
                    secondsSpan.textContent = checkValue(s);
            }
        }
        }, oneSec);
    
    }
    
    const right_team_timer=()=>{
    const oneSec = 1000
    const container2 = document.getElementById('team2Timer');
    while (container2.hasChildNodes()){
        container2.firstChild.remove()
    };
    let dataHours = secureLocalStorage.getItem("hour-right") ? checkValue(secureLocalStorage.getItem("hour-right")):container2.getAttribute('data-hours2')
    let dataMinutes = secureLocalStorage.getItem("min-right") ? checkValue(secureLocalStorage.getItem("min-right")):container2.getAttribute('data-minutes2')
    let dataSeconds = secureLocalStorage.getItem("sec-right") ? checkValue(secureLocalStorage.getItem("sec-right")):container2.getAttribute('data-seconds2')
    let timerEnd = container2.getAttribute('data-timer-end-right')
    let timerOnEndMsg = "data-timer-end-right";
    

    if (dataHours == '' || dataHours == null || dataHours == NaN) {
        dataHours = "0";
    }
    if (dataMinutes == '' || dataMinutes == null || dataMinutes == NaN) {
        dataMinutes = "0";
    }
    if (dataSeconds == '' || dataSeconds == null || dataSeconds == NaN) {
        dataSeconds = "0";
    }

    
    var hoursSpan = document.createElement('span')
    hoursSpan.id = "span_hour"
    var minutesSpan = document.createElement('span')
    minutesSpan.id = "span_minutes"
    var secondsSpan = document.createElement('span')
    secondsSpan.id = "span_seconds"
    var separator1 = document.createElement('span')
    separator1.id = "span_separator_1"
    var separator2 = document.createElement('span')
    separator2.id = "span_separator_2"


    let separatorValue = ":"
    let max = 59,


    s = parseInt(dataSeconds) > max ? max : parseInt(dataSeconds),
    m = parseInt(dataMinutes) > max ? max : parseInt(dataMinutes),
    h = parseInt(dataHours);


    secondsSpan.classList.add('time');
    minutesSpan.classList.add('time');
    hoursSpan.classList.add('time');
    separator1.classList.add('separator');
    separator1.textContent = separatorValue;
    separator2.classList.add('separator');
    separator2.textContent = separatorValue;

    hoursSpan.textContent =  checkValue(dataHours);
    minutesSpan.textContent =  checkValue(dataMinutes);
    secondsSpan.textContent = checkValue(dataSeconds);

    let children = [hoursSpan, separator1, minutesSpan, separator2, secondsSpan];

    for (let child of children) {
        container2.appendChild(child);
    }
   

    const timer = function (sv, mv, hv) {
            s = parseInt(sv);
            m = parseInt(mv);
            h = parseInt(hv);
        
            if (s > 0) {
                return s -= 1;
            } else {
                s = max;
                if (m > 0) {
                    return m -= 1;
                } else {
                    m = max;
                    if (h > 0) {
                        return h -= 1;
                    }
                }
            }
        }
    const finished2 = () => {
        max = 0;
        let timerEnd = container2.getAttribute(timerOnEndMsg);
        container2.setAttribute(timerOnEndMsg, "You're done!");
        if (timerEnd == '' || timerEnd== null) {
            container2.textContent = "You're done!";
        } else {
            container2.textContent = timerEnd;
        }
    }

    const counter2 = setInterval(() => {
        if(secureLocalStorage.getItem("rightspeak")){
            if (h == 0 && m == 0 && s == 0) {
                clearInterval(counter2, finished2());
            }
            if (s >= 0) {
                    timer(s, m, h);
                    secureLocalStorage.setItem('hour-right',checkValue(h))
                    secureLocalStorage.setItem('min-right',checkValue(m))
                    secureLocalStorage.setItem('sec-right',checkValue(s))

                    hoursSpan.textContent = checkValue(h);
                    minutesSpan.textContent = checkValue(m);
                    secondsSpan.textContent = checkValue(s);
            }
        }
        }, oneSec);

    }

    
    useEffect(()=>{
        return()=>{
            // alert("from timer")
            if((team === "left_team") && (document.getElementById("team1Timer"))){

                    left_team_timer()
            }
            if((team === "right_team") && (document.getElementById("team2Timer"))){
                    right_team_timer()
                
            }
            if(speakingTeam === "both_team"){
                if((team === "left_team") && (document.getElementById("team1Timer"))){
                    left_team_timer()

                }
                if((team === "right_team") && (document.getElementById("team2Timer"))){
                    right_team_timer()

                }
            }
        
        
            

        }
    },[rightPause,leftPause,speakingTeam,member])
    
return(
    <>
   
    {team == "left_team"
     ?
     <div id="team1Timer" className={joined_as === "participant"?"timer":"team-timer"} data-hours1={hour} data-minutes1={minutes} data-seconds1={second}></div>
     :
     <div id="team2Timer" className={joined_as === "participant"?"timer":"team-timer"} data-hours2={hour} data-minutes2={minutes}  data-seconds2={second}></div>
     
    }   
    </>

    // <>
   
    // <div id="team1Timer" className="team-timer" data-hours1={hour} data-minutes1={minutes} data-seconds1='0'>

    // </div>
    
    // </>
    
);
}

export default TeamTimer